export enum EGroup {
  recent = 'recent',
  smileys = 'Smileys & Emotion',
  people = 'People & Body',
  animals_and_nature = 'Animals & Nature',
  food_and_drink = 'Food & Drink',
  travel_and_places = 'Travel & Places',
  activity = 'Activities',
  objects = 'Objects',
  symbols = 'Symbols',
  flags = 'Flags',
}

export type TEmojiLib = {
  group: EGroup;
  name: string;
};

export type TEmoji = {
  name: string;
  keywords: string[];
  char: string;
  group: EGroup;
};
